/** * Created by lobin on 2019/1/24. */
<template>
  <div class="resumeInit">
    <img src="../../assets/images/tips_img.png" alt="" />
    <p>您还没有简历，你可以：</p>
    <div class="resumeInit-btns">
      <el-button
        type="primary"
        icon="el-icon-upload2"
        @click="$router.push('/resumeoptimize?step=0')"
        >上传简历并解析</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="$router.push('/baseInfoAdd')"
        >创建简历</el-button
      >
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.resumeInit {
  min-height: 600px;
  background: #fff;
  width: 1200px;
  margin: 20px auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    width: 100%;
    text-align: center;
    font-size: 16px;
    margin: 60px 0 40px;
    span {
      color: #1e88e5;
    }
  }
  &-btns {
    width: 100%;
    text-align: center;
  }
}
</style>
